export default __webpack_public_path__ + "static/blond-4fdcd63cf60b748ec7204e99d3ed123c.svg";